import { getTrackBackground } from 'react-range'
import { TTNormsPro } from '../../../theme.css'
import { Range } from '..'

export const RangeTwoThumbs = <
  GValues extends [number] | [number, number],
>(props: {
  values: GValues
  min: number
  max: number
  onChange: (values: GValues) => void
}) => {
  return (
    <Range
      values={props.values}
      min={props.min}
      max={props.max}
      onChange={props.onChange}
      renderTrack={({ props: trackProps, children }) => (
        <div
          onMouseDown={trackProps.onMouseDown}
          onTouchStart={trackProps.onTouchStart}
          style={{
            ...trackProps.style,
            height: '36px',
            display: 'flex',
            width: '100%',
            padding: '0 1rem',
          }}
        >
          <div
            ref={trackProps.ref}
            style={{
              height: '0.1875rem',
              width: '100%',
              borderRadius: '4px',
              background: getTrackBackground({
                values: props.values,
                colors: ['#1B1B1B', '#C62929', '#1B1B1B'],
                min: props.min,
                max: props.max,
                rtl: false,
              }),
              alignSelf: 'center',
            }}
          >
            {children}
          </div>
        </div>
      )}
      renderThumb={({ index, props: thumbProps, value }) => (
        <div
          {...thumbProps}
          key={thumbProps.key}
          style={{
            ...thumbProps.style,
            height: '0.75rem',
            width: '0.75rem',
            borderRadius: '50%',
            backgroundColor: '#FFF',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '-1rem',
              left: `${(100 / props.max) * value}`,
              display: 'flex',
              flexDirection: 'row',
              color: '#fff',
              fontWeight: '400',
              fontSize: '0.625rem',
              fontFamily: TTNormsPro,
              whiteSpace: 'nowrap',
            }}
          >
            {`${props.values[index].toFixed(0)} BB`}
          </div>
        </div>
      )}
    />
  )
}
